export const validate = (values ,t) => {
    let errors = {};


    // Validate old password field
    if (!values.old_password) {
        errors.old_password = t("old_password_required") ;
    } else if (values.old_password.length < 3) {
        errors.old_password = t("old_password_min_length") ;
    }

    // Validate new password field
    if (!values.new_password) {
        errors.new_password = t("new_password_required");
    } else if (values.new_password.length < 3) {
        errors.new_password =  t("new_password_min_length");
    }

    // Validate confirm password field
    if (!values.confirm_password) {
        errors.confirm_password = t("confirm_password_required");
    } else if (values.confirm_password !== values.new_password) {
        errors.confirm_password = t("confirm_password_mismatch") ;
    }

    return errors;
};
